import React from "react";
import { motion } from "framer-motion";
import { FiRefreshCw } from "react-icons/fi";

const LocationDisplay = ({
  location,
  error,
  isLoading,
  onRefresh,
  onClick,
  showFullAddress = false,
}) => {
  const formatAddress = (loc) => {
    if (!loc) return "";

    if (loc.details) {
      const { details } = loc;
      return `${details.subLocality || details.locality}${
        details.pincode ? `, ${details.pincode}` : ""
      }`.trim();
    }

    return loc.address || "";
  };

  if (isLoading) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="location-loading"
        onClick={onClick}
      >
        <motion.span
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        >
          <FiRefreshCw />
        </motion.span>
        Detecting location...
      </motion.div>
    );
  }

  if (error) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="location-error"
        onClick={onClick}
      >
        <span>⚠️ Location Error</span>
        <button onClick={onRefresh} className="location-retry-btn">
          Retry
        </button>
      </motion.div>
    );
  }

  if (location) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="location-display"
        onClick={onClick}
      >
        <span className="location-icon">📍</span>
        <span className="location-text">
          {showFullAddress
            ? location.address || formatAddress(location)
            : formatAddress(location) || "Select location"}
        </span>
        {showFullAddress && (
          <div className="location-coordinates">
            {location.coordinates.latitude.toFixed(4)},{" "}
            {location.coordinates.longitude.toFixed(4)}
          </div>
        )}
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="location-prompt"
      onClick={onClick}
    >
      <span className="location-icon">📍</span>
      <span>Select location</span>
    </motion.div>
  );
};

export default React.memo(LocationDisplay);
